import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Home, Library as LibraryIcon, BarChart3, Bell, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { key: "", icon: Home, label: "Home", path: "/app" },
  { key: "library", icon: LibraryIcon, label: "Library", path: "/app/library" },
  { key: "progress", icon: BarChart3, label: "Progress", path: "/app/progress" },
  { key: "notifications", icon: Bell, label: "Alerts", path: "/app/notifications" },
  { key: "profile", icon: User, label: "Profile", path: "/app/profile" },
];

export default function NurseShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const active = location.pathname.replace("/app", "").replace("/", "") || "";

  return (
    <div className="min-h-screen bg-[#fcf9f8]">
      <div className="max-w-md mx-auto w-full min-h-screen bg-[#fcf9f8] relative pb-24">
        <div className="mitra-fade-in px-4 pt-6">
          <Outlet />
        </div>
        <nav
          data-testid="nurse-tab-bar"
          className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-[#E5E7EB] flex justify-around items-stretch h-[68px] z-40"
        >
          {TABS.map((t) => {
            const Icon = t.icon;
            const isActive = active === t.key;
            return (
              <button
                key={t.label}
                data-testid={`nurse-tab-${t.label.toLowerCase()}`}
                onClick={() => navigate(t.path)}
                className="flex-1 flex flex-col items-center justify-center gap-1 min-h-[48px] transition-colors"
              >
                <Icon className="w-5 h-5" strokeWidth={2} color={isActive ? "#003d9b" : "#9CA3AF"} />
                <span className={`text-[11px] font-semibold ${isActive ? "text-[#003d9b]" : "text-[#9CA3AF]"}`}>
                  {t.label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
